import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=5b097d5a"
import script from "./detailPage.vue?vue&type=script&lang=js"
export * from "./detailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b097d5a')) {
      api.createRecord('5b097d5a', component.options)
    } else {
      api.reload('5b097d5a', component.options)
    }
    module.hot.accept("./detailPage.vue?vue&type=template&id=5b097d5a", function () {
      api.rerender('5b097d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComponent/detailPage.vue"
export default component.exports